module.exports = __webpack_public_path__ + "img/purple.56739d94.svg";